import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ContractNamePipe } from '@vfde-fe/ngx-lib/pipes/contract-name';
import { MsisdnPipe } from '@vfde-fe/ngx-lib/pipes/msisdn';
import { CoreUiModule } from './core-ui.modules';
import { UiWidgetModule } from './widget-ui.module';
import { GeneralErrorComponent } from './shared-components/general-error/general-error.component';
import { UnauthorizedComponent } from './shared-components/unauthorized/unauthorized.component';

/** SharedModule */@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        CoreUiModule,
        UiWidgetModule,
    ],
    declarations: [
        UnauthorizedComponent,
        GeneralErrorComponent,
    ],
    exports: [
        TranslateModule,
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        CoreUiModule,
        UiWidgetModule,
    ],
    providers: [
        ContractNamePipe,
        MsisdnPipe,
    ],

})
export class SharedModule { }
